export enum CivilStatusAuthorizations {
  NascitaCaricamento = 'IMMAGINE.ATTO.CARICAMENTO',
  MorteCaricamento = 'IMMAGINE.ATTO.CARICAMENTO',
  MatrimonioCaricamento = 'IMMAGINE.ATTO.CARICAMENTO',
  UnioneCivileCaricamento = 'IMMAGINE.ATTO.CARICAMENTO',
  NascitaRicerca = 'ATTO.RICERCA',
  MatrimonioRicerca = 'ATTO.RICERCA',
  MorteRicerca = 'ATTO.RICERCA',
  AttoModifica = 'ATTO.MODIFICA',
  AttoSostituzione = 'IMMAGINE.ATTO.SOSTITUZIONE',
  TimbroCertificatoQuery = 'TESTO.STAMPA.CERTIFICAZIONE.QUERY',
  TimbroCertificatoAdd = 'TESTO.STAMPA.CERTIFICAZIONE.ADD',
  TimbroCertificatoUpdate = 'TESTO.STAMPA.CERTIFICAZIONE.UPDATE',
  TimbroCertificatoDelete = 'TESTO.STAMPA.CERTIFICAZIONE.DELETE',
  AnnotazioneQuery = 'TESTO.ANNOTAZIONE.QUERY',
  AnnotazioneAdd = 'TESTO.ANNOTAZIONE.ADD',
  AnnotazioneUpdate = 'TESTO.ANNOTAZIONE.UPDATE',
  AnnotazioneDelete = 'TESTO.ANNOTAZIONE.DELETE',
  AnnotazioneIntNaz = 'ATTO.ANNOTAZIONI',
  DocumentiRegistroQuery = 'REGISTRO.ATTO.QUERY',
  DocumentiRegistroAdd = 'REGISTRO.ATTO.ADD',
  DocumentiRegistroUpdate = 'REGISTRO.ATTO.UPDATE',
  DocumentiRegistroDelete = 'REGISTRO.ATTO.DELETE',
  DocumentiSerieQuery = 'SERIE.ATTO.QUERY',
  DocumentiSerieAdd = 'SERIE.ATTO.ADD',
  DocumentiSerieUpdate = 'SERIE.ATTO.UPDATE',
  DocumentiSerieDelete = 'SERIE.ATTO.DELETE',
  StampaCertificazione = 'ATTO.CERTIFICA',
  RicercaAttoUnioneCivile = 'ATTO.RICERCA',
  RicercaAttoCittadinanza = 'IMMAGINE.ATTO.CARICAMENTO',
  AnscNascitaInsert = 'ANSC.NASCITA.INS',
  AnscMorteInsert = 'ANSC.MORTE.INS',
  AnscMatrimonioInsert = 'ANSC.MATRIMONIO.INS',
  AnscUnioneInsert = 'ANSC.UNIONECIVILE.INS',
  AnscCittadinanzaInsert = 'ANSC.CITTADINANZA.INS',
  AnscDominioQuery = 'ANSC.DOMINIO.QUERY',
  AnscDominioInsert = 'ANSC.DOMINIO.ADD',
  AnscDominioUpdate = 'ANSC.DOMINIO.UPDATE',
  AnscDominioDelete = 'ANSC.DOMINIO.DELETE',
  AnscComuniQuery = 'ANSC.COMUNE.QUERY',
  AnscComuniAdd = 'ANSC.COMUNE.ADD',
  AnscComuniUpdate = 'ANSC.COMUNE.UPDATE',
  AnscComuniDelete = 'ANSC.COMUNE.DELETE',
  AnscVisualizzaLuogoNascita = 'ANSC.LUOGONASCITA.QUERY',
  AnscModificaLuogoNascita = 'ANSC.LUOGONASCITA.UPDATE',
  AnscEliminaLuogoNascita = 'ANSC.LUOGONASCITA.DELETE',
  AnscAggiungiLuogoNascita = 'ANSC.LUOGONASCITA.ADD',
  AnscTestoModifica = 'ANSC.TESTOEVENTO.UPDATE',
  AnscComunicazione = 'ANSC.COMUNICAZIONI.STAMPA',
  AnscReportistica = 'ANSC.REPORT.STAMPA',
  AnscPec = 'ANSC.PEC.QUERY',
  AnscArchivio = 'ANSC.ARCHIVIO.QUERY',
  AnsRegistroEmergenza = 'ANSC.REGISTRO.EMERGENZA',
  AnscAttiRicerca = 'ANSC.ATTI.RICERCA',
  AnscBozzaRicerca = 'ANSC.BOZZE.RICERCA',
  AttoCertifica = 'ATTO.CERTIFICA',
  AttoStampa = 'ATTO.STAMPA',
  AnscNotificheRicerca = 'ANSC.NOTIFICHE.RICERCA',
}

export const CivilStatusBirthUpload = [CivilStatusAuthorizations.NascitaCaricamento];

export const CivilStatusMarriageUpload = [CivilStatusAuthorizations.MatrimonioCaricamento];

export const CivilStatusDeathUpload = [CivilStatusAuthorizations.MorteCaricamento];

export const CivilStatusUnionCivilUpload = [CivilStatusAuthorizations.UnioneCivileCaricamento];

export const CivilStatusBirthSearch = [CivilStatusAuthorizations.NascitaRicerca];

export const CivilStatusMarriageSearch = [CivilStatusAuthorizations.MatrimonioRicerca];

export const CivilStatusDeathSearch = [CivilStatusAuthorizations.MorteRicerca];

export const CivilStatusStampCertificate = [
  CivilStatusAuthorizations.TimbroCertificatoQuery,
  CivilStatusAuthorizations.TimbroCertificatoAdd,
  CivilStatusAuthorizations.TimbroCertificatoUpdate,
  CivilStatusAuthorizations.TimbroCertificatoDelete,
];

export const CivilStatusPrintFormula = [];

export const CivilStatusNotesText = [
  CivilStatusAuthorizations.AnnotazioneQuery,
  CivilStatusAuthorizations.AnnotazioneAdd,
  CivilStatusAuthorizations.AnnotazioneUpdate,
  CivilStatusAuthorizations.AnnotazioneDelete,
];

export const CivilStatusDocumentRegistry = [
  CivilStatusAuthorizations.DocumentiRegistroQuery,
  CivilStatusAuthorizations.DocumentiRegistroAdd,
  CivilStatusAuthorizations.DocumentiRegistroUpdate,
  CivilStatusAuthorizations.DocumentiRegistroDelete,
];

export const CivilStatusDocumentSerie = [
  CivilStatusAuthorizations.DocumentiSerieQuery,
  CivilStatusAuthorizations.DocumentiSerieAdd,
  CivilStatusAuthorizations.DocumentiSerieUpdate,
  CivilStatusAuthorizations.DocumentiSerieDelete,
];

export const AnscDomainManagement = [
  CivilStatusAuthorizations.AnscDominioQuery,
  CivilStatusAuthorizations.AnscDominioInsert,
  CivilStatusAuthorizations.AnscDominioUpdate,
  CivilStatusAuthorizations.AnscDominioDelete,
];
export const CivilStatusBirthplaces = [
  CivilStatusAuthorizations.AnscVisualizzaLuogoNascita,
  CivilStatusAuthorizations.AnscAggiungiLuogoNascita,
  CivilStatusAuthorizations.AnscEliminaLuogoNascita,
  CivilStatusAuthorizations.AnscModificaLuogoNascita,
];

export const CivilUnionList = [CivilStatusAuthorizations.RicercaAttoUnioneCivile];

export const CitizenshipList = [CivilStatusAuthorizations.RicercaAttoCittadinanza];

export const AnscBorn = [CivilStatusAuthorizations.AnscNascitaInsert];

export const AnscDeath = [CivilStatusAuthorizations.AnscMorteInsert];

export const AnscMarriage = [CivilStatusAuthorizations.AnscMatrimonioInsert];

export const AnscUnion = [CivilStatusAuthorizations.AnscUnioneInsert];

export const AnscCitizenship = [CivilStatusAuthorizations.AnscCittadinanzaInsert];

export const AnscMunicipality = [
  CivilStatusAuthorizations.AnscComuniQuery,
  CivilStatusAuthorizations.AnscComuniAdd,
  CivilStatusAuthorizations.AnscComuniUpdate,
  CivilStatusAuthorizations.AnscComuniDelete,
];

export const AnscUpdateText = [CivilStatusAuthorizations.AnscTestoModifica]; // non più usata

export const AnscCommunication = [CivilStatusAuthorizations.AnscComunicazione];

export const AnscReport = [CivilStatusAuthorizations.AnscReportistica];

export const AnscPec = [CivilStatusAuthorizations.AnscPec];

export const AnscArchive = [CivilStatusAuthorizations.AnscArchivio];

export const AnscRegisterEmergency = [CivilStatusAuthorizations.AnsRegistroEmergenza];

export const AnscResearchAct = [CivilStatusAuthorizations.AnscAttiRicerca];

export const AnscResearchActDraft = [CivilStatusAuthorizations.AnscBozzaRicerca];

export const ActCertified = [CivilStatusAuthorizations.AttoCertifica];

export const ActPrint = [CivilStatusAuthorizations.AttoStampa];

export const AnscResearchNotifications = [CivilStatusAuthorizations.AnscNotificheRicerca];

// mettere le nuove autorizzazione
export const CivilStatusAuthorizationsList = [
  ...CivilStatusBirthUpload,
  ...CivilStatusDeathUpload,
  ...CivilStatusMarriageUpload,
  ...CivilStatusBirthSearch,
  ...CivilStatusDeathSearch,
  ...CivilStatusMarriageSearch,
  ...CivilStatusNotesText,
  ...CivilStatusDocumentRegistry,
  ...CivilStatusDocumentSerie,
  ...CivilUnionList,
  ...CitizenshipList,
  ...AnscBorn,
  ...AnscDeath,
  ...AnscMarriage,
  ...AnscUnion,
  ...AnscCitizenship,
  ...AnscDomainManagement,
  ...AnscMunicipality,
  ...CivilStatusBirthplaces,
  ...AnscCommunication,
  ...AnscReport,
  ...AnscPec,
  ...AnscArchive,
  ...AnscResearchAct,
  ...AnscResearchActDraft,
  ...ActCertified,
  ...ActPrint,
  ...AnscResearchNotifications,
];
